<template>
  <div class="main-buttons d-flex">
    <b-button
      v-tooltip="{title:$tc('global.sample',2), placement: tooltipPlacement}"
      v-shortkey="['alt', '1']"
      qa="diagnosis-main-buttons-sample-section-button"
      :class="{'btn-active': showContent === FORM_VIEWS_CONFIGURATION.SAMPLE_VIEW.id}"
      class="btn__icon btn__icon--primary p-1 flex-fill"
      @shortkey.prevent="$emit('changeViewSelected', FORM_VIEWS_CONFIGURATION.SAMPLE_VIEW.id)"
      @click="$emit('changeViewSelected', FORM_VIEWS_CONFIGURATION.SAMPLE_VIEW.id)"
    >
      <i
        class="far fa-prescription-bottle"
        aria-hidden="true"
      />
      <div class="bubble">
        <vtBubble
          v-if="samplesCount"
          :number="samplesCount"
          :info="true"
        />
      </div>
    </b-button>
    <b-button
      v-tooltip="{title:$t('diagnosis.btns.globalMacro'), placement: tooltipPlacement}"
      v-shortkey="['alt', '2']"
      qa="diagnosis-main-buttons-global-macroscopy-section-button"
      :class="{'btn-active': showContent === FORM_VIEWS_CONFIGURATION.MACRO_VIEW.id}"
      class="btn__icon btn__icon--primary p-1 flex-fill"
      @shortkey.prevent="$emit('changeViewSelected', FORM_VIEWS_CONFIGURATION.MACRO_VIEW.id)"
      @click="$emit('changeViewSelected', FORM_VIEWS_CONFIGURATION.MACRO_VIEW.id)"
    >
      <i
        class="far fa-align-justify"
        aria-hidden="true"
      />
    </b-button>
    <b-button
      v-tooltip="{title:$t('diagnosis.btns.comprehensiveDiagnosis'), placement: tooltipPlacement}"
      v-shortkey="['alt', '3']"
      qa="diagnosis-main-buttons-comprehensive-diagnosis-section-button"
      :class="{'btn-active': showContent === FORM_VIEWS_CONFIGURATION.DIAGNOSIS_INTEGRAL_VIEW.id}"
      class="btn__icon btn__icon--primary p-1 flex-fill"
      @shortkey.prevent="$emit('changeViewSelected', FORM_VIEWS_CONFIGURATION.DIAGNOSIS_INTEGRAL_VIEW.id)"
      @click="$emit('changeViewSelected', FORM_VIEWS_CONFIGURATION.DIAGNOSIS_INTEGRAL_VIEW.id)"
    >
      <i
        class="far fa-comment-alt-medical"
        aria-hidden="true"
      />
      <div
        v-if="hasComprehensiveDiagnosis"
        class="section-bubble"
      />
    </b-button>
    <b-button
      v-tooltip="{title:$tc('diagnosis.btns.complementary',2), placement: tooltipPlacement}"
      v-shortkey="['alt', '4']"
      qa="diagnosis-main-buttons-complementaries-section-button"
      :class="{'btn-active': showContent === FORM_VIEWS_CONFIGURATION.COMPLEMENTARIES_VIEW.id}"
      class="btn__icon btn__icon--primary p-1 flex-fill"
      @shortkey.prevent="$emit('changeViewSelected', FORM_VIEWS_CONFIGURATION.COMPLEMENTARIES_VIEW.id)"
      @click="$emit('changeViewSelected', FORM_VIEWS_CONFIGURATION.COMPLEMENTARIES_VIEW.id)"
    >
      <i
        class="far fa-layer-plus"
        aria-hidden="true"
      />
      <div class="bubble">
        <vtBubble
          v-if="complementariesCount"
          :number="complementariesCount"
          :info="true"
        />
      </div>
    </b-button>
    <b-button
      id="case-more"
      qa="diagnosis-main-buttons-ellipsis-button"
      class="btn__icon btn__icon--primary p-1 flex-fill"
    >
      <i
        class="fas fa-ellipsis-v"
        aria-hidden="true"
      />
    </b-button>
    <b-popover
      target="case-more"
      placement="bottomright"
      triggers="click blur"
    >
      <div class="ap-popover">
        <ul>
          <!-- TODO: Se mantendrá oculto por orden de Javier hasta 2021 -->
          <!--<li class="py-1">
                        <a type="button" class="linkbtn" @click="$refs.shareCaseModalWrapper.show()">
                          <i class="far fa-share mr-2" aria-hidden="true"></i>
                          {{$t('diagnosis.btns.share')}}
                        </a>
                      </li>-->
          <!-- TODO: Esta opción de menú aparece cuando un estudio se comparte y permite dejar de compartir -->
          <!--<li class="py-1">
                          <a type="button" class="linkbtn" @click="$refs.shareCaseModal.show()">
                              <i class="far fa-times-circle mr-2" aria-hidden="true"></i>
                              {{$t('diagnosis.modals.stopSharing')}}
                          </a>
                      </li>-->
          <li
            v-if="visibleConsultations"
          >
            <b-button
              qa="diagnosis-main-buttons-consults-a"
              @click="$emit('showConsultationModal')"
            >
              {{ $tc('diagnosis.btns.consult', 2) }}
            </b-button>
          </li>
          <!-- TODO: Se mantendrá oculto por orden de Javier hasta 2021 -->
          <!--<li class="py-1">
                        <a type="button" class="linkbtn">
                          <i class="far fa-laptop mr-2" aria-hidden="true"></i>
                          {{$t('diagnosis.btns.digitalization')}}
                        </a>
                      </li>-->
          <!--<li class="py-1">
                        <a type="button" class="linkbtn">
                          <i class="far fa-border-all mr-2" aria-hidden="true"></i>
                          {{$t('diagnosis.btns.pdho')}}
                        </a>
                      </li>
                      <li class="py-1">
                        <a type="button" class="linkbtn">
                          <i class="far fa-laptop-medical mr-2" aria-hidden="true"></i>
                          {{$t('diagnosis.btns.injury')}}
                        </a>
                      </li>-->
          <li>
            <b-button
              qa="diagnosis-main-buttons-send-notification-a"
              @click="showCustomNotificationsModal()"
            >
              {{ $t('diagnosis.btns.issueNotification') }}
            </b-button>
          </li>
          <li>
            <b-button
              qa="diagnosis-main-buttons-report-history-a"
              :disabled="!$_isCaseValidated(caseData && caseData.status.code)"
              @click="$emit('openReportHistoryModal')"
            >
              {{ $t('diagnosis.btns.reportHistory') }}
            </b-button>
          </li>
          <div class="horizontal-divider my-1" />
          <li
            v-if="$_canCreateIncident()"
          >
            <b-button
              qa="diagnosis-main-buttons-incidents-a"
              :disabled="!$_canBeIncidentCreatedToCase(caseData)"
              @click="$emit('openIncidentFormModal')"
            >
              {{ $t('diagnosis.btns.incident') }}
            </b-button>
          </li>
          <li
            v-if="$_canAttachDocumentToCase() && !$_isCaseValidated(caseData && caseData.status.code)"
          >
            <b-button
              qa="diagnosis-main-buttons-attachment-a"
              :disabled="!$_canBeDocumentAttachedToCase(caseData)"
              @click="$emit('openAddFileModal')"
            >
              {{ $t('diagnosis.btns.attach') }}
            </b-button>
          </li>
          <li>
            <b-button
              qa="diagnosis-main-buttons-show-in-global-locator"
              @click="showInGlobalLocator(caseData.casenumber)"
            >
              {{ $t('global.showInGlobalLocator') }}
            </b-button>
          </li>
        </ul>
      </div>
    </b-popover>
    <modal-wrapper ref="sendNotificationModalWrapper">
      <send-notification-modal
        ref="sendNotificationModal"
        :laboratory-id="laboratoryId"
        :case-id="caseId"
        :type="CUSTOM_NOTIFICATION_TYPE.CASE"
        @customSentNotificationsUpdated="$emit('customSentNotificationsUpdated')"
      />
    </modal-wrapper>
    <modal-wrapper ref="shareCaseModalWrapper">
      <share-case-modal ref="shareCaseModal" />
    </modal-wrapper>
  </div>
</template>

<script>
import VtBubble from '@/components/common/VtBubble'
import FORM_VIEWS_CONFIGURATION from '@/modules/diagnosisModule/views/form/config/formViewsConfiguration'
import SendNotificationModal from '@/modules/diagnosisModule/views/form/modals/SendNotificationModal'
import ShareCaseModal from '@/modules/diagnosisModule/views/form/modals/ShareCaseModal'
import { CUSTOM_NOTIFICATION_TYPE } from '@/api/resources/customNotifications/customNotificationsService'
import { CaseOperationGuardMixin } from '@/api/operations/mixins/guards/case-operation-guard.mixin'
import { IncidentOperationGuardMixin } from '@/api/operations/mixins/guards/incident-operation-guard.mixin'
import DiagnosisCaseMixin from '@/modules/diagnosisModule/mixins/DiagnosisCaseMixin'

export default {
    name: 'DiagnosisMainButtons',
    components: {
        VtBubble,
        SendNotificationModal,
        ShareCaseModal
    },
    mixins: [
        CaseOperationGuardMixin,
        IncidentOperationGuardMixin,
        DiagnosisCaseMixin
    ],
    props: {
        showContent: { type: Number },
        tooltipPlacement: { type: String },
        laboratoryId: { type: Number }
    },
    computed: {
        FORM_VIEWS_CONFIGURATION() {
            return FORM_VIEWS_CONFIGURATION
        },
        CUSTOM_NOTIFICATION_TYPE() {
            return CUSTOM_NOTIFICATION_TYPE()
        },
        hasComprehensiveDiagnosis() {
            return this.caseData?.hasComprehensiveDiagnosis
        },
        complementariesCount() {
            return this.caseData?.complementariesCount
        },
        samplesCount() {
            return this.caseData?.samplesCount
        }
    },
    methods: {
        showInGlobalLocator(label) {
            this.$eventHub.$emit('show-in-global-locator', label)
        },
        showCustomNotificationsModal(showCustomNotificationsModalSidepanel) {
            this.$refs.sendNotificationModalWrapper.show([showCustomNotificationsModalSidepanel])
        }
    }
}
</script>

<style lang="scss" scoped>
.main-buttons .section-bubble {
    bottom: 10px;
    margin-right: 5px;
}

.main-buttons .bubble{
  position:absolute;
  bottom: 3px;
}

.main-buttons.flex-column .bubble{
  right: 3px;
}

.main-buttons.justify-content-around .bubble{
  right: 15%;
}

.main-buttons .btn{
  position: relative;
}

.main-buttons.flex-column .btn{
  height: 35px;
  transition: .3s;
  border-radius: 0;
}

.main-buttons.justify-content-around .btn.btn-active {
  border-radius: 0;
}

.main-buttons.justify-content-around .btn{
  height: 35px;
  transition: .3s;
  border-radius: 0;
}

.main-buttons .btn{
    margin-right: 0 !important;
}

.pop-case {
  padding-left: 0;
  padding-bottom: 0;
  margin-bottom: 0;
  width: 200px;
}

.pop-case li {
  list-style: none !important;
  padding: 10px !important;
  border-bottom: 1px solid rgb(218, 218, 218);
}

</style>

<style lang="scss">

.case-compact-card .main-buttons .btn{
    padding: 10px 0 !important;
}

</style>
